const rawTerminals = (process.env.REACT_APP_TERMINAL_IDS ?? 'CRMOB,ESALG,BHKBS').split(',');
const defaultTerminalFromEnv = process.env.REACT_APP_DEFAULT_TERMINAL ?? 'CRMOB';

export type DatabaseType = 'POSTGRESQL' | 'ORACLE' | 'EXTERNAL';

export interface TerminalOption {
  id: string; // sanitized id used in API calls
  rawId: string; // original value from env
  label: string;
  defaultDatabase: DatabaseType;
}

const sanitized = (value: string) => value.replace(/_PG$/i, '').trim();

export const terminalOptions: TerminalOption[] = rawTerminals
  .map((value) => value.trim())
  .filter((value) => value.length > 0)
  .map((value) => ({
    id: sanitized(value),
    rawId: value,
    label: sanitized(value),
    defaultDatabase: value.toUpperCase().endsWith('_PG') ? 'POSTGRESQL' : 'ORACLE',
  }));

// Find terminal matching REACT_APP_DEFAULT_TERMINAL, or fall back to first terminal, or hardcoded fallback
export const defaultTerminalOption: TerminalOption =
  terminalOptions.find((opt) => opt.rawId === defaultTerminalFromEnv) ||
  terminalOptions[0] || {
    id: 'ESALG',
    rawId: 'ESALG',
    label: 'ESALG',
    defaultDatabase: 'ORACLE',
  };

export const sanitizeTerminalId = (value: string) => sanitized(value);
